"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TableHead = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TableCell = require("../TableCell");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = {
  "TableHead--sticky": "TableHead__TableHead--sticky___1YzE0"
};
var defaultProps = {
  isSticky: false,
  testId: 'cf-ui-table-head'
};

var TableHead = function TableHead(props) {
  var className = props.className,
      testId = props.testId,
      offsetTop = props.offsetTop,
      isSticky = props.isSticky,
      children = props.children,
      otherProps = (0, _objectWithoutProperties2["default"])(props, ["className", "testId", "offsetTop", "isSticky", "children"]);
  var classNames = (0, _classnames["default"])(className, (0, _defineProperty2["default"])({}, styles["TableHead--sticky"], isSticky));
  return /*#__PURE__*/_react["default"].createElement(_TableCell.TableCellContext.Provider, {
    value: _objectSpread(_objectSpread({}, _TableCell.contextOptions.head), {}, {
      offsetTop: offsetTop || 0
    })
  }, /*#__PURE__*/_react["default"].createElement("thead", (0, _extends2["default"])({
    className: classNames,
    "data-test-id": testId
  }, otherProps), children));
};

exports.TableHead = TableHead;
TableHead.defaultProps = defaultProps;
var _default = TableHead;
exports["default"] = _default;